<!-- <div class="card text-center mb-3">
  <div class="card-body py-4">
    <p class="mb-4 h5">{{ ctaMessage }}</p>
    <button class="btn btn-primary px-4 btn-lg" (click)="onCtaClick()">{{ ctaButtonText }}</button>
  </div>
</div> -->
<div class="cta-panel">
  <p>{{ ctaMessage }}</p>
  <button class="cta-btn" (click)="onCtaClick()">{{ ctaButtonText }}</button>
</div>